module.exports = __webpack_public_path__ + "img/app-bilibili.6ff4b6da.webp";